import { defineMessages } from "react-intl";

export const messages = defineMessages({
  selectAll: {
    id: "ari.management.sortAndFilter.selectAll",
    defaultMessage: "Select all",
  },
  unSelectAll: {
    id: "ari.management.sortAndFilter.unSelectAll",
    defaultMessage: "Unselect all",
  },
});
